'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-header-simple {\n  position: fixed;\n  width: 100%;\n  border-bottom: #ccc solid 2px;\n  height: 60px;\n  top: 0;\n  left: 0;\n  z-index: 20;\n  background-color: #fff;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n";
styleInject_es(css_248z);
